import axios from '../../plugins/axios';

export const listNote = ({ commit }, payload ) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  if (payload.userId){
    return axios.get(`/api/note?order=${payload.order}&id=${payload.userId}`, config)
    .then(response => {
      const notes = response.data
      console.log(notes)
      commit('SET_NOTES', { notes })
    })
    .catch(err => err.response)
  }else{
    return axios.get(`/api/note?order=${payload.order}`, config)
    .then(response => {
      const notes = response.data
      commit('SET_NOTES', { notes })
    })
    .catch(err => err.response)
  }

};

export const updateNote = ({}, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.put(`/api/note/${payload.id}`, payload, config)
    .then(response => response)
    .catch(error => error.response)
};

export const deleteNote = ({}, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.delete(`/api/note/${payload.id}`, config)
    .then((response) => response)
    .catch((error) => error.response)
}

export const createNote = ({}, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.post('/api/note', payload, config)
    .then(response => response)
    .catch(error => error.response)
}
